var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingHeaderProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.6665C8.63999 2.6665 2.66666 8.63984 2.66666 15.9998C2.66666 23.3598 8.63999 29.3332 16 29.3332C23.36 29.3332 29.3333 23.3598 29.3333 15.9998C29.3333 8.63984 23.36 2.6665 16 2.6665ZM16 7.99984C18.5733 7.99984 20.6667 10.0932 20.6667 12.6665C20.6667 15.2398 18.5733 17.3332 16 17.3332C13.4267 17.3332 11.3333 15.2398 11.3333 12.6665C11.3333 10.0932 13.4267 7.99984 16 7.99984ZM16 26.6665C13.2933 26.6665 10.0933 25.5732 7.81332 22.8265C10.0667 21.0665 12.9067 19.9998 16 19.9998C19.0933 19.9998 21.9333 21.0665 24.1867 22.8265C21.9067 25.5732 18.7067 26.6665 16 26.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingHeaderProfile);
export default __webpack_public_path__ + "static/media/LandingHeaderProfile.926390c4919f0167dad412628cde18a9.svg";
export { ForwardRef as ReactComponent };